import { Box, Typography } from "@mui/material"
import React from "react"

export default function SectionBox({
    icon,
    title,
    subtitle,
    children,
    titleSize = "16px",
    subtitleSize = "13px",
}) {
    return (
        <Box
            sx={{
                border: "1px solid #E4E7EC",
                borderRadius: "8px",
                padding: "1.5rem",
                mb: "3vh",
            }}
        >
            {/* Header (Title + Subtitle) */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.3rem",
                    mb: "1.5rem",
                }}
            >
                {/* Title Row */}
                <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                    {icon}
                    <Typography
                        sx={{
                            fontWeight: 600,
                            color: "#101828",
                            fontSize: titleSize,
                        }}
                    >
                        {title}
                    </Typography>
                </Box>

                {/* Optional subtitle */}
                {subtitle && (
                    <Typography
                        sx={{
                            color: "#667085",
                            fontSize: subtitleSize,
                            fontWeight: 400,
                            ml: icon ? "1.8rem" : 0, // align nicely with text if icon present
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>

            {/* Inner content */}
            {children}
        </Box>
    )
}
